import {
  ACTION_GET_CAR_LOYALTY_PROGRAM,
  ACTION_GET_CAR_LOYALTY_PROGRAM_SUCCESS,
  ACTION_GET_CAR_LOYALTY_PROGRAM_FAILURE,
  ACTION_EMPTY_CAR_LOYALTY_PROGRAM,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export function getCarLoyaltyProgram() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'loyalty-programs/cars',
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function emptyResults() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_CAR_LOYALTY_PROGRAM,
      payload: null,
    });
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_CAR_LOYALTY_PROGRAM,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_CAR_LOYALTY_PROGRAM_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_CAR_LOYALTY_PROGRAM_FAILURE,
    payload: responseJSON,
  };
}
